import React from 'react';
import Navigation from '../components/shared/Navigation';

const AboutPage = () => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-50 to-white">
      <Navigation />
      <div className="pt-20">
        <div className="container mx-auto px-4 py-12">
          <div className="max-w-3xl mx-auto">
            <h1 className="text-4xl font-bold text-[#1d2840] mb-8">About SuperOwl</h1>
            
            <div className="prose prose-lg">
              <p className="text-gray-600 mb-8">
                At SuperOwl, we believe that AI-powered conversational chat should be simple, accessible, and affordable for everyone—especially for small and medium businesses (SMBs). While big enterprises have the resources to deploy advanced AI solutions, we want to level the playing field by offering cutting-edge AI chat technology that is easy to integrate and cost-effective.
              </p>

              <h2 className="text-2xl font-bold text-[#1d2840] mt-12 mb-4">Our Mission</h2>
              <p className="text-gray-600 mb-8">
                To empower SMBs with seamless AI conversational chat that enhances customer engagement without breaking the bank. We aim to simplify AI adoption, helping businesses stay competitive in an era dominated by technology-driven interactions.
              </p>

              <h2 className="text-2xl font-bold text-[#1d2840] mt-12 mb-4">Our Vision</h2>
              <p className="text-gray-600 mb-8">
                A world where AI chat is available with minimal cost—or even free. We achieve this by leveraging smart, efficient, and scalable technology that reduces operational expenses while delivering a high-quality conversational experience.
              </p>

              <h2 className="text-2xl font-bold text-[#1d2840] mt-12 mb-4">Why SuperOwl?</h2>
              <ul className="list-none space-y-4 text-gray-600 mb-8">
                <li className="flex items-center">
                  <span className="text-[#3DA3DC] mr-2">•</span>
                  <span><strong>Affordable AI Chat</strong> – Advanced chatbot solutions without enterprise-level costs.</span>
                </li>
                <li className="flex items-center">
                  <span className="text-[#3DA3DC] mr-2">•</span>
                  <span><strong>Easy Integration</strong> – Plug-and-play technology that works with your existing systems.</span>
                </li>
                <li className="flex items-center">
                  <span className="text-[#3DA3DC] mr-2">•</span>
                  <span><strong>Empowering SMBs</strong> – Helping small businesses stay ahead in the AI revolution.</span>
                </li>
                <li className="flex items-center">
                  <span className="text-[#3DA3DC] mr-2">•</span>
                  <span><strong>Scalable & Smart</strong> – A solution that grows with your business needs.</span>
                </li>
              </ul>

              <p className="text-gray-600 mt-12 text-center font-medium">
                Join us as we redefine AI-powered conversations for businesses of all sizes.<br/>
                <span className="text-[#3DA3DC]">SuperOwl – AI made simple, for everyone.</span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutPage;
